import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './modal.magic.css.js';
import script from './modal.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"modal",staticClass:"modal",class:[("modal--" + _vm.size), {
        'has-no-header': !_vm.dismissible && !_vm.$slots.header,
        'modal--show-as-modal-on-mobile': _vm.showAsModalOnMobile
    }],attrs:{"role":"dialog","data-v-test-id":"modal","aria-labelledby":"modalTitle","aria-describedby":"modalDescription","part":_vm.$p('modal', [("modal--" + _vm.size), {
        'has-no-header': !_vm.dismissible && !_vm.$slots.header,
    }])}},[(_vm.dismissible || _vm.$slots.header)?_c('header',{staticClass:"header",class:("header--" + _vm.size),attrs:{"id":"modalTitle","part":_vm.$p('header', ("header--" + _vm.size))}},[_c('div',{staticClass:"action",attrs:{"part":"action"}},[(_vm.backArrow && _vm.dismissible)?[(!_vm.backArrowContent)?_c('magic-ui-button',{staticClass:"button button--left",attrs:{"icon":"","tiny":"","no-margin":"","variant":"transparent","part":"button button--left","aria-label":"←","data-v-test-id":"modal-go-back-btn"},on:{"click":_vm.goBack}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"left-arrow-long","part":"icon"}})],1):_c('magic-ui-link',{staticClass:"link",attrs:{"part":"link","data-v-test-id":"modal-link"},domProps:{"innerHTML":_vm._s(_vm.$t(_vm.backArrowContent))},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}})]:_vm._e(),_vm._v(" "),(_vm.dismissible)?_c('magic-ui-button',{staticClass:"button button--right",attrs:{"data-v-test-id":"modal-close-button","icon":"","tiny":"","no-margin":"","variant":"transparent","part":"button button--right","aria-label":"✕"},on:{"click":function($event){return _vm.close()}}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"close","part":"icon"}})],1):_vm._e()],2),_vm._v(" "),_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('section',{staticClass:"body",class:("body--" + _vm.size),attrs:{"id":"modalDescription","part":_vm.$p('body', ("body--" + _vm.size)),"data-v-test-id":"modal-body"}},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7016e50a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-7016e50a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
